export default "__VITE_ASSET__BRJECMew__"